import * as Constants from './constants'

const initialState = {
  list: [],
  listKho: [],
  item: {},
  type: Constants.TONKHO_LIST_INITING,
  listRequesting: false,
  requesting: false,
  isPopupLoading: false,
  successful: false,
  messages: [],
  errors: [],
  formData: {},
  callback: function () { },
}

const reducer = function tonKhoReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.TONKHO_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.TONKHO_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.TONKHO_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.TONKHO_DETAIL_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.TONKHO_DETAIL_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: action.data.records[0] || {},
        listDvt: action.data.listDvt,
        listNganhHang: action.data.listNganhHang,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.TONKHO_DETAIL_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.TONKHO_UPDATE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.TONKHO_UPDATE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.payload.data,
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }]
      }

    case Constants.TONKHO_UPDATE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.TONKHO_KHO_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
      }

    case Constants.TONKHO_KHO_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listKho: action.data,
      }

    case Constants.TONKHO_KHO_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listKho: [],
      }
      case Constants.TONKHO_EXPORT_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.TONKHO_EXPORT_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.TONKHO_EXPORT_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
      case Constants.TONKHO_UPLOAD_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isPopupLoading: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.TONKHO_UPLOAD_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        dataErr: action.payload.data,
        type: action.type,
        isPopupLoading: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }]
      }

    case Constants.TONKHO_UPLOAD_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isPopupLoading: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/TonKho/reducer.js